export enum ESwitchEnum {
  close,
  open,
}
